import { WebsiteRoute } from 'dew-types'
import React, { ReactNode, useEffect, useMemo, useState } from 'react'

import { Router } from './index'
import { matchRoutes } from './matchRoutes'

export interface BrowserRouterProps {
  routes: WebsiteRoute[]
  children: ReactNode
}

export function BrowserRouter({ routes, children }: BrowserRouterProps) {
  const [location, setLocation] = useState(() => {
    return {
      pathname: document.location.pathname,
      search: document.location.search,
    }
  })

  // Add events listenner when mounted
  useEffect(() => {
    const cb = () => {
      setLocation({
        pathname: document.location.pathname,
        search: document.location.search,
      })
    }
    const toTop = () => {
      window.scrollTo({ top: 0 })
    }
    window.addEventListener('popstate', cb)
    window.addEventListener('historychange', cb)
    window.addEventListener('historychange', toTop)
    return () => {
      window.removeEventListener('popstate', cb)
      window.removeEventListener('historychange', cb)
      window.removeEventListener('historychange', toTop)
    }
  }, [])

  const matchedRoutes = useMemo(() => {
    return matchRoutes(location.pathname, routes)
  }, [location, routes])

  return (
    <Router
      navigator={{
        pushState: (...args) => {
          window.history.pushState(...args)
          window.dispatchEvent(new Event('historychange', {}))
        },
        navigate: (to) => {
          window.history.pushState({}, '', to)
          window.dispatchEvent(new Event('historychange', {}))
        },
      }}
      matchedRoutes={matchedRoutes}
      routes={routes}
      location={location}
    >
      {children}
    </Router>
  )
}
